import { gql } from '@apollo/client';

export default gql`
  mutation deleteContract($_id: String) {
    deleteContract(_id: $_id) {
      ok
      message
      error
    }
  }
`;
